export const weekDays = [
  { id: 1, name: 'Mo', value: 'Monday' },
  { id: 2, name: 'Tu', value: 'Tuesday' },
  { id: 3, name: 'We', value: 'Wednesday' },
  { id: 4, name: 'Th', value: 'Thursday' },
  { id: 5, name: 'Fr', value: 'Friday' },
  { id: 6, name: 'St', value: 'Saturday' },
  { id: 7, name: 'Sa', value: 'Sunday' },
];

export const shiftStart = [
  { id: 1, name: '06:00', value: '06:00' },
  { id: 2, name: '07:00', value: '07:00' },
  { id: 3, name: '08:00', value: '08:00' },
  { id: 4, name: '09:00', value: '09:00' },
  { id: 5, name: '10:00', value: '10:00' },
  { id: 6, name: '11:00', value: '11:00' },
  { id: 7, name: '12:00', value: '12:00' },
  { id: 8, name: '13:00', value: '13:00' },
  { id: 9, name: '14:00', value: '14:00' },
];

export const shiftEnd = [
  { id: 1, name: '14:00', value: '14:00' },
  { id: 2, name: '15:00', value: '15:00' },
  { id: 3, name: '16:00', value: '16:00' },
  { id: 4, name: '17:00', value: '17:00' },
  { id: 5, name: '18:00', value: '18:00' },
  { id: 6, name: '19:00', value: '19:00' },
  { id: 7, name: '20:00', value: '20:00' },
  { id: 8, name: '21:00', value: '21:00' },
  { id: 9, name: '22:00', value: '22:00' },
  { id: 10, name: '23:00', value: '23:00' },
  { id: 11, name: '00:00', value: '00:00' },
];
